<body>
  <div class="container-fluid h-100 bd fd">
    @if (loading) {
      <app-loading></app-loading>
    }
    <router-outlet></router-outlet>
  </div>
</body>
